module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowCate-slide"
  }, [_c('div', {
    staticClass: "w-180 bg-wh",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "p-t-20"
  }, [_c('div', {
    staticClass: "h-40 p-l-10 flowCate-item",
    on: {
      "click": _vm.selectCommon
    }
  }, [_c('el-badge', {
    attrs: {
      "value": _vm.allCount
    }
  }, [_c('div', {
    staticClass: "w-100 h-40 p-l-20 fz-14",
    class: {
      'c-icon-blue': _vm.common == true, 'c-black': _vm.common != true
    }
  }, [(_vm.all) ? _c('div', [_vm._v("全部")]) : _c('div', [_vm._v("常用流程")]), _vm._v(" ")])])]), _vm._v(" "), _vm._l((_vm.flowCates), function(item) {
    return _c('div', {
      staticClass: "p-l-10 flowCate-item",
      on: {
        "click": function($event) {
          _vm.selectCate(item)
        }
      }
    }, [_c('el-badge', {
      staticClass: "mark",
      attrs: {
        "value": item.case_num
      }
    }, [_c('div', {
      staticClass: "w-100 h-40 p-l-20 fz-14 ellipsis ovf-hd",
      class: {
        'c-icon-blue': item.selected, 'c-black': !item.selected
      }
    }, [_vm._v(_vm._s(item.name))])])])
  })], true)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ed5b53a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/common/flowCate.vue
// module id = 1834
// module chunks = 2